import React, { useState } from 'react';
import { Form, Input, Button, InputNumber,Spin } from 'antd';


import {
  pdUpdatePassword,
} from "./../../services";

const NewPassword = ({passwordLogin,authToken}) => {
  const [form] = Form.useForm();

  const [confirmPasswordError, setConfirmPasswordError] = useState(null);
  const [loader, setLoading] = useState(null);

  const validatePasswords = (rule, value) => {
    if (!value) {
      return Promise.resolve(); // Allow for empty confirm password initially
    }

    if (form.getFieldValue('password') !== value) {
      setConfirmPasswordError('Passwords do not match!');
      return Promise.reject('Passwords do not match!');
    }

    setConfirmPasswordError(null); // Clear error if passwords match
    return Promise.resolve();
  };

  const handleFormSubmit =async (values) => {
    setLoading(true);
    values.authToken = authToken;
    console.log(values); // Access submitted password and confirm password
    const response = await pdUpdatePassword(values);
    
    passwordLogin(values);

    console.log(response);

    // Perform additional validation or API calls here (optional)

    // Reset form and clear error message
    
    form.resetFields();
    setConfirmPasswordError(null);
  };

  return (
     <Spin spinning={loader}>
    <Form onFinish={handleFormSubmit} form={form} className="stripe-loginform">

      <Form.Item
        name="password"
        
        rules={[
          { required: true, message: 'Please enter your password' },
          { pattern: /[A-Z]/, message: 'Password must contain at least one uppercase letter' },
          { pattern: /[a-z]/, message: 'Password must contain at least one lowercase letter' },
          { pattern: /[0-9]/, message: 'Password must contain at least one number' },
          { min: 8, message: 'Password must be at least 8 characters long' },
        ]}
        hasFeedback
      >
        <Input.Password placeholder="Enter Password" />
      </Form.Item>

      <Form.Item
        name="confirm_password"
       
        rules={[
          { required: true, message: 'Please confirm your password' },
          ({ getFieldValue }) => ({
            validator: validatePasswords,
            // Display custom error message if provided
            errors: confirmPasswordError,
          }),
        ]}
        hasFeedback
      >
        <Input.Password placeholder="Confirm Password" />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
          Save Password
        </Button>
      </Form.Item>
    </Form>
    </Spin>
  );
};

export default NewPassword;
